// extracted by mini-css-extract-plugin
export default {"button":"IconButton_button__zrj8x","primary":"IconButton_primary__MVKSf","disable":"IconButton_disable__vMy5r"};